<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18DNi5K/tc-custom/9781466806207.jpg?1731883558400" alt="This image is the cover for the book Coming Storm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Coming Storm
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Lambda Literary Award Finalist; Winner of the Ferro-Grumley Award</b><br/><br/><b>Set against the backdrop of a traditional boys' school in upstate New York, <i>The Coming Storm</i> is a delicately and brilliantly rendered tale that reveals the most closely held secrets of the human heart. </b><br/><br/>Russell's award-winning novel is the story of four interlocking lives - Louis Tremper, the headmaster at the Forge School; his wife Claire; Tracey Parker, a 25-year old gay man and recently hired teacher at the Forge School; and Noah Lathrop III, a troubled student - all of whom struggle with their own inner demons, desires, and conflicted loyalties. When Tracey and Noah become involved in an illicit relationship, dark incidents from the school's past begin colliding with the current growing confusion that all of them must face. <br/><br/>Compelling and poignant, this is the finest work yet from one of best contemporary American novelists.<br/><br/><br/><i>Stonewall Inn Editions</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Russell
      </h2>
      
      <p class="authorDescription body article"><P>Paul Russell is the author of three novels—<I>The Salt Point</I>,<I> Boys of Life</I>, and<I> Sea of Tranquillity</I>—as well as<I> The Gay 100</I>, a work of non-fiction. He is Professor of English at Vassar College and lives in upstate New York.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macmillan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03f60eae